import { BASE_PERMISSIONS, TabWithPermissionsInterface } from 'base';

export const USER_MENU_GROWTH: TabWithPermissionsInterface[] = [
  {
    title: 'companyMasterData',
    url: '/administration/company-master-data',
    permissionsAllowed: [BASE_PERMISSIONS.FEATURE_ADMIN_MASTER_DATA, BASE_PERMISSIONS.FEATURE_ADMIN_DOCUMENTS],
    rolesAllowed: [],
    id: 10,
  },
  {
    title: 'user.management',
    url: '/administration/user-management',
    permissionsAllowed: [BASE_PERMISSIONS.FEATURE_ADMIN_USERS],
    rolesAllowed: [],
    id: 20,
  },
  {
    title: 'administration.dataManagement',
    url: '/administration/data-management',
    permissionsAllowed: [],
    rolesAllowed: [],
    id: 25,
  },
  {
    title: 'customer.related.temporaryEmployment',
    url: '/administration/employee-lease',
    permissionsAllowed: [],
    rolesAllowed: [],
    id: 30,
  },
  {
    title: 'administration.manageBranch',
    url: '/administration/branch-management',
    permissionsAllowed: [BASE_PERMISSIONS.FEATURE_ADMIN_BRANCHES],
    rolesAllowed: [],
    id: 40,
  },
  {
    title: 'administration.userSettings',
    url: '/administration/user-settings',
    permissionsAllowed: [],
    rolesAllowed: [],
    id: 50,
  },
];
